import React, { useState } from 'react';

import { Form, InputGroup } from 'react-bootstrap';

import { searchIcon, close } from 'assets';

interface SearchProps {
  placeholder: string;
  handleSearch: (value: string) => any;
  handleReset: () => any;
  active: boolean;
  defaultValue?: string;
  dataTestId?: string;
  autoSearch?: boolean;
  autoReset?: boolean;
}

const Search = ({
  placeholder,
  handleSearch,
  handleReset,
  active,
  defaultValue,
  dataTestId,
  autoSearch = false,
  autoReset = false
}: SearchProps) => {
  const [input, setInput] = useState<string>(defaultValue || '');
  const handleResetInput = () => {
    setInput('');
    handleReset();
  };
  return (
    <InputGroup>
      <Form.Control
        id="search"
        type="text"
        data-test={dataTestId}
        placeholder={placeholder}
        value={input}
        onChange={(e) => {
          setInput(e.target.value);
          if (e.target.value) {
            if (autoSearch) {
              handleSearch(e.target.value.trim());
            }
          } else {
            if (autoReset) {
              handleResetInput();
            }
          }
        }}
        onKeyDown={(e: React.KeyboardEvent) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            handleSearch(input.trim());
          }
          if (e.key === 'Escape') {
            handleResetInput();
          }
        }}
      />
      <div
        data-test={`${dataTestId}-reset`}
        className="cursor-pointer"
        onClick={() => (active ? handleResetInput() : handleSearch(input.trim()))}
      >
        <InputGroup.Text className="h-100">
          <img src={active ? close : searchIcon} />
        </InputGroup.Text>
      </div>
    </InputGroup>
  );
};

export default Search;
